/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Skill_TInputs */

const en_mk_tut_skill_t = /** @type {(inputs: Mk_Tut_Skill_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills: writing down a way of working, once`)
};

const id_mk_tut_skill_t = /** @type {(inputs: Mk_Tut_Skill_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill: menuliskan cara kerja sekali saja`)
};

/**
* | output |
* | --- |
* | "Skills: writing down a way of working, once" |
*
* @param {Mk_Tut_Skill_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_skill_t = /** @type {((inputs?: Mk_Tut_Skill_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Skill_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_skill_t(inputs)
	return en_mk_tut_skill_t(inputs)
});